import React from 'react'
import './App.css'

import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { createTheme, responsiveFontSizes } from '@mui/material'
import { teal } from '@mui/material/colors'
import Box from '@mui/material/Box'

import { AddressSwapPage } from './components/pages'

const App = () => {
  const theme = responsiveFontSizes(createTheme({
    palette: {
      primary: {
        main: teal[900],
      },
      secondary: {
        main: teal[900],
      },
    },
  }))

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <Box>
        <AddressSwapPage />
      </Box>
    </ThemeProvider>
  )
}

export default App
